module.exports = __webpack_public_path__ + "img/icon_map_black.12595e19.svg";